import clsx from 'clsx';
import { Badge } from 'app/_shared'

import styles from './Throbber.module.scss'

export default ({ active, className }) => !!active && (
  <div className={clsx(styles.container, className)}>
    <Badge className={styles.badge} throb />
  </div>
)
